// External
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
// import { Store } from '@ngrx/store';

// Internal
// import { LOADED_SERVICES, RESET_LOADED_SERVICES } from '../../../../store/actions/values.actions';
// import { State } from '../../../../store/main-state';

@Injectable({
    providedIn: 'root'
})

export class LoadingService {

    loadedServices: Observable<number>;

    constructor(
        ) {
            // this.loadedServices = this.store.select(x => x.loadedServices);
        }

    on() {
        // this.store.dispatch({type: LOADED_SERVICES});
    }

    off() {
        // this.store.dispatch({type: RESET_LOADED_SERVICES});
    }

    setLoader(variable) {
        if ( variable === 'on') {
            this.on();
        } else {
            this.off();
        }
    }
}
